<template>
  <div class="voucher-detail-page">
    <div class="figma-detail-card">
      <!-- Header -->
      <div class="figma-detail-header">
        <div class="figma-breadcrumb">
          <span class="breadcrumb-prev" style="cursor:pointer" @click="$router.back()">{{ $t('committeeVoucherManage.pageTitle') }}</span>
          <i class="el-icon-arrow-right"></i>
          <span class="breadcrumb-current">{{ $t('committeeVoucherManage.detail.title') }}</span>
        </div>
      </div>

      <!-- 详情信息区 -->
      <div class="detail-info-section">
        <div class="detail-info-inner">
          <div class="detail-info-row">
            <div class="info-attachment">
              <div class="info-label">{{ $t('committeeVoucherManage.form.attachment') }}：</div>
              <img v-if="detailData.attachmentUrl" class="attachment-img" :src="detailData.attachmentUrl" alt="attachment" />
              <div v-else class="attachment-placeholder">-</div>
            </div>
            <div class="info-cols">
              <div class="info-col">
                <div class="info-item">
                  <span class="info-label">{{ $t('committeeVoucherManage.form.voucherNo') }}：</span>
                  <span class="info-value">{{ detailData.voucherNo || '-' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">{{ $t('committeeVoucherManage.form.payMethod') }}：</span>
                  <span class="info-value">{{ detailData.payMethodName || '-' }}</span>
                </div>
              </div>
              <div class="info-col">
                <div class="info-item">
                  <span class="info-label">{{ $t('committeeVoucherManage.form.feeType') }}：</span>
                  <span class="info-value">{{ detailData.feeTypeName || '-' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">{{ $t('committeeVoucherManage.form.amount') }}：</span>
                  <span class="info-value">{{ detailData.amountText || '-' }}</span>
                </div>
              </div>
              <div class="info-col">
                <div class="info-item">
                  <span class="info-label">{{ $t('committeeVoucherManage.form.feeItem') }}：</span>
                  <span class="info-value">{{ detailData.feeItem || '-' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">{{ $t('committeeVoucherManage.form.time') }}：</span>
                  <span class="info-value">{{ detailData.startTime || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 变更记录 -->
      <div class="change-record-section">
        <div class="section-title">{{ $t('committeeVoucherManage.detail.changeRecord') }}</div>
        <div class="record-table-wrap">
          <el-table
            :data="changeRecords"
            style="width: 100%"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
          >
            <el-table-column :label="$t('committeeVoucherManage.table.id')" width="248">
              <template slot-scope="scope">{{ scope.row.idText }}</template>
            </el-table-column>
            <el-table-column :label="$t('committeeVoucherManage.table.feeType')" width="336">
              <template slot-scope="scope">
                <span :class="['fee-type-tag', scope.row.feeType === 'INCOME' ? 'fee-type-income' : 'fee-type-expense']">
                  {{ scope.row.feeTypeName }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="feeItem" :label="$t('committeeVoucherManage.table.feeItem')" width="207" show-overflow-tooltip />
            <el-table-column :label="$t('committeeVoucherManage.table.amount')" width="230">
              <template slot-scope="scope">
                <span :style="{ color: scope.row.feeType === 'INCOME' ? '#0E76FF' : '#1D2129' }">{{ scope.row.amountText }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="changeTime" :label="$t('committeeVoucherManage.detail.changeTime')" width="339" show-overflow-tooltip />
            <el-table-column prop="operator" :label="$t('committeeVoucherManage.detail.operator')" width="219" show-overflow-tooltip />
          </el-table>
        </div>
        <div class="figma-pagination">
          <span class="pagination-total">共{{ changePagination.total }}条</span>
          <el-pagination
            :current-page="changePagination.page"
            :page-size="changePagination.row"
            layout="prev, pager, next"
            :total="changePagination.total"
            @current-change="handleChangePage"
          />
          <el-select v-model="changePagination.row" size="small" class="pagination-size-select" @change="handleChangeSize">
            <el-option label="10条/页" :value="10" />
            <el-option label="20条/页" :value="20" />
            <el-option label="50条/页" :value="50" />
          </el-select>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import { getVoucherDetail, listVoucherChangeRecord } from '@/api/committee/voucherManageApi'

export default {
  name: 'VoucherDetail',
  data() {
    return {
      loading: false,
      detailData: {},
      changeRecords: [],
      changePagination: { total: 0, page: 1, row: 10 }
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px', padding: '0' }
    },
    cellStyle({ row }) {
      const rowIndex = this.changeRecords.indexOf(row)
      const base = { color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', padding: '0', fontWeight: rowIndex % 2 === 1 ? '500' : '400' }
      return rowIndex % 2 === 1 ? { ...base, background: '#F8FBFF' } : { ...base, background: 'white' }
    },
    getFeeTypeName(feeType) {
      if (feeType === 'INCOME') return this.$t('committeeVoucherManage.form.income')
      if (feeType === 'EXPENSE') return this.$t('committeeVoucherManage.form.expense')
      return feeType || '-'
    },
    getPayMethodName(payMethod) {
      const map = {
        'BANK_TRANSFER': this.$t('committeeVoucherManage.form.bankTransfer'),
        'CASH': this.$t('committeeVoucherManage.form.cash'),
        'WECHAT': this.$t('committeeVoucherManage.form.wechat'),
        'ALIPAY': this.$t('committeeVoucherManage.form.alipay')
      }
      return map[payMethod] || payMethod || '-'
    },
    getFirstAttachment(row) {
      const attachments = row.attachments || row.attachmentList || row.files || []
      if (Array.isArray(attachments) && attachments.length > 0) {
        return attachments[0] || {}
      }
      return {}
    },
    getAttachmentUrl(row) {
      const firstAttachment = this.getFirstAttachment(row)
      return firstAttachment.attachmentUrl || firstAttachment.url || firstAttachment.fileUrl || row.attachmentUrl || row.attachment || ''
    },
    normalizeRow(row) {
      const firstAttachment = this.getFirstAttachment(row)
      const attachmentUrl = this.getAttachmentUrl(row)
      return {
        ...row,
        idText: row.id || row.voucherId || '-',
        feeType: row.feeType || '',
        feeTypeName: this.getFeeTypeName(row.feeType),
        payMethodName: this.getPayMethodName(row.payMethod),
        amountText: row.amount ? (Number(row.amount).toFixed(2) + ' 元') : '-',
        startTime: row.startTime || row.time || row.createTime || '-',
        changeTime: row.createTime || row.changeTime || row.updateTime || '-',
        attachmentUrl,
        fileName: row.fileName || firstAttachment.fileName || firstAttachment.name || ''
      }
    },
    getDetailData(res) {
      if (!res) return {}
      if (Array.isArray(res.data)) return res.data[0] || {}
      if (res.data && typeof res.data === 'object') return res.data
      if (Array.isArray(res.records)) return res.records[0] || {}
      if (Array.isArray(res)) return res[0] || {}
      return res
    },
    async loadDetail() {
      const voucherId = this.$route.query.voucherId
      const communityId = this.$route.query.communityId
      if (!voucherId) {
        this.$message.error('缺少凭证ID')
        return
      }
      try {
        this.loading = true
        const res = await getVoucherDetail({ voucherId, communityId })
        const data = this.getDetailData(res)
        this.detailData = this.normalizeRow(data)
        // 加载变更记录
        this.loadChangeRecords()
      } catch (e) {
        this.$message.error(this.$t('committeeVoucherManage.message.fetchError'))
      } finally {
        this.loading = false
      }
    },
    async loadChangeRecords() {
      const voucherId = this.$route.query.voucherId
      const communityId = this.$route.query.communityId
      if (!voucherId) return
      try {
        const res = await listVoucherChangeRecord({
          voucherId,
          communityId,
          page: this.changePagination.page,
          row: this.changePagination.row
        })
        const list = (res && res.data) || (res && res.records) || []
        this.changeRecords = list.map(item => this.normalizeRow(item))
        this.changePagination.total = (res && res.total) || list.length
      } catch (e) {
        this.changeRecords = []
      }
    },
    handleChangePage(page) { this.changePagination.page = page; this.loadChangeRecords() },
    handleChangeSize(size) { this.changePagination.row = size; this.changePagination.page = 1; this.loadChangeRecords() }
  }
}
</script>

<style scoped>
.voucher-detail-page {
  height: calc(100vh - 60px);
  background: #EBF2FA;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.figma-detail-card {
  background: white;
  border-radius: 0 0 12px 12px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

/* Header */
.figma-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
  flex-shrink: 0;
}

.figma-breadcrumb {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 600;
}

.breadcrumb-prev {
  color: #8C9BB4;
}

.breadcrumb-current {
  color: #1D2129;
}

.figma-breadcrumb i {
  color: #8C9BB4;
  font-size: 14px;
}

.figma-btn-back {
  width: 78px !important;
  height: 38px !important;
  padding: 0 !important;
  background: white !important;
  border: 1px solid #0E76FF !important;
  color: #0E76FF !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}

/* 详情信息区 */
.detail-info-section {
  padding: 20px 24px 0;
  flex-shrink: 0;
}

.detail-info-inner {
  background: #F3F7FB;
  border-radius: 8px;
  padding: 20px 24px;
}

.detail-info-row {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.info-attachment {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-attachment .info-label {
  font-size: 14px;
  font-weight: 500;
  color: #8C9BB4;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
}

.attachment-img {
  width: 65px;
  height: 65px;
  border-radius: 8px;
  object-fit: cover;
}

.attachment-placeholder {
  width: 65px;
  height: 65px;
  border-radius: 8px;
  background: #DCE6F5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8C9BB4;
  font-size: 14px;
}

.info-cols {
  flex: 1;
  display: flex;
  gap: 48px;
}

.info-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  font-size: 14px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500;
  line-height: 22px;
}

.info-item .info-label {
  color: #8C9BB4;
}

.info-item .info-value {
  color: #1D2129;
}

/* 变更记录 */
.change-record-section {
  margin: 20px 24px 0;
  background: white;
  border-radius: 12px;
  border: 1px solid #EBF2FA;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.section-title {
  padding: 20px 24px 12px;
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  flex-shrink: 0;
}

.record-table-wrap {
  flex: 1;
  min-height: 0;
  padding: 0 24px;
  overflow: auto;
}

.record-table-wrap >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: none;
}

.record-table-wrap >>> .el-table::before {
  display: none;
}

.record-table-wrap >>> .el-table__header th {
  background: #EBF2FA !important;
  border: none !important;
}

.record-table-wrap >>> .el-table__body td {
  border: none !important;
}

.record-table-wrap >>> .el-table th .cell,
.record-table-wrap >>> .el-table td .cell {
  padding-left: 24px;
  padding-right: 24px;
  line-height: 22px;
}

/* 费用类型标签 */
.fee-type-tag {
  display: inline-block;
  padding: 2px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 400;
  line-height: 24px;
}

.fee-type-expense {
  background: rgba(255, 105, 0, 0.10);
  border: 1px solid #FF6900;
  color: #FF6900;
}

.fee-type-income {
  background: rgba(14, 118, 255, 0.10);
  border: 1px solid #0E76FF;
  color: #0E76FF;
}

/* 分页 */
.figma-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;
  gap: 8px;
  flex-shrink: 0;
}

.pagination-total {
  font-size: 14px;
  color: #1D2129;
  margin-right: 4px;
}

.figma-pagination >>> .el-pagination {
  display: flex;
  align-items: center;
  padding: 0;
}

.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next {
  width: 32px;
  height: 32px;
  border-radius: 2px;
  background: white;
}

.figma-pagination >>> .el-pager li {
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  color: #1D2129;
  font-weight: 600;
}

.figma-pagination >>> .el-pager li.active {
  background: #E8F3FF;
  color: #0E76FF;
}

.pagination-size-select {
  width: 92px;
  margin-left: 8px;
}

.pagination-size-select >>> .el-input__inner {
  height: 32px;
  border-radius: 8px;
  background: #F2F3F5;
  border: none;
  font-size: 14px;
  color: #1D2129;
}

/* 底部操作栏 */
.figma-bottom-bar {
  margin: 20px 24px 24px;
  padding: 20px 24px;
  background: white;
  border-radius: 12px;
  border: 1px solid #EBF2FA;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.figma-btn-cancel {
  width: 98px !important;
  height: 38px !important;
  padding: 0 !important;
  background: white !important;
  border: 1px solid #0E76FF !important;
  color: #0E76FF !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}

.figma-btn-submit {
  width: 98px !important;
  height: 38px !important;
  padding: 0 !important;
  background: #0E76FF !important;
  border: none !important;
  color: white !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}

@media (max-width: 1024px) {
  .info-cols {
    flex-direction: column;
    gap: 16px;
  }
  .detail-info-row {
    flex-direction: column;
  }
}
</style>
